import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class StaffsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      company_id: null,
      email: null,
      civil_state: null,
      phone1: null,
      phone2: null,
      blood_type: null,
      dados_bancarios: null,
      date_of_birth: null,
      country_birth: null,
      uf_birth: null,
      city_birth: null,
      address: null,
      number: null,
      complement: null,
      neighborhood: null,
      city: null,
      uf: null,
      country: null,
      pis: null,
      cep: null,
      photo: null,
      cpf: null,
      identity: null,
      id_uf: null,
      id_exp: null,
      id_date: null,
      ctps_uf: null,
      ctps: null,
      ctps_expedition: null,
      escola_formacao: null,
      scholarly: null,
      confidence_us: null,
      expire_us: null,
      confidence_eu: null,
      expire_eu: null,
      passport: null,
      passport_expiration: null,
      voting_title: null,
      voting_title_zone: null,
      voting_title_session: null,
      cnh: null,
      cnh_expiration: null,
      reservista: null,
      reservista_cat: null,
      certificado_militar: null,
      certificado_militar_ministerio: null,
      certificado_militar_obs: null,
      certificado_militar_obs: null,
      crea: null,
      crea_titulo: null,
      crea_expedicao: null,
      crea_validade: null,
      aso: null,
      hired: null,
      fired: null,
      mom: null,
      dad: null,
      license: null,
      canac: null,
      inscription: null,
      hour_value: null,
      sispat: null,
      sapiens_code: null,
      uf_list: [],
      companies_select: [],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/colaborador/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            uf_list: responseJson.data.uf_list,
          });
        }
      }).then(() => {
        var url = config.get('api_sigtrip') + '/empresas/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ companies_select: responseJson.data });
          }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     }); });
    });
  }

  add(event) {
    event.preventDefault();
    var data = new FormData();
    var photo = document.querySelector(".input-photo").files[0];
    data.append("imagem", photo);

    data.append("name", this.state.name);
    data.append("company_id", this.state.company_id);
    data.append("email", this.state.email);
    data.append("civil_state", this.state.civil_state);
    data.append("phone1", this.state.phone1);
    data.append("phone2", this.state.phone2);
    data.append("blood_type", this.state.blood_type);
    data.append("dados_bancarios", this.state.dados_bancarios);
    data.append("date_of_birth", this.state.date_of_birth);
    data.append("country_birth", this.state.country_birth);
    data.append("uf_birth", this.state.uf_birth);
    data.append("city_birth", this.state.city_birth);
    data.append("address", this.state.address);
    data.append("number", this.state.number);
    data.append("complement", this.state.complement);
    data.append("neighborhood", this.state.neighborhood);
    data.append("city", this.state.city);
    data.append("uf", this.state.uf);
    data.append("country", this.state.country);
    data.append("pis", this.state.pis);
    data.append("cep", this.state.cep);
    data.append("photo", this.state.photo);
    data.append("cpf", this.state.cpf);
    data.append("identity", this.state.identity);
    data.append("id_uf", this.state.id_uf);
    data.append("id_exp", this.state.id_exp);
    data.append("id_date", this.state.id_date);
    data.append("ctps_uf", this.state.ctps_uf);
    data.append("ctps", this.state.ctps);
    data.append("ctps_expedition", this.state.ctps_expedition);
    data.append("escola_formacao", this.state.escola_formacao);
    data.append("scholarly", this.state.scholarly);
    data.append("confidence_us", this.state.confidence_us);
    data.append("expire_us", this.state.expire_us);
    data.append("confidence_eu", this.state.confidence_eu);
    data.append("expire_eu", this.state.expire_eu);
    data.append("passport", this.state.passport);
    data.append("passport_expiration", this.state.passport_expiration);
    data.append("voting_title", this.state.voting_title);
    data.append("voting_title_zone", this.state.voting_title_zone);
    data.append("voting_title_session", this.state.voting_title_session);
    data.append("cnh", this.state.cnh);
    data.append("cnh_expiration", this.state.cnh_expiration);
    data.append("reservista", this.state.reservista);
    data.append("reservista_cat", this.state.reservista_cat);
    data.append("certificado_militar", this.state.certificado_militar);
    data.append("certificado_militar_ministerio", this.state.certificado_militar_ministerio);
    data.append("certificado_militar_obs", this.state.certificado_militar_obs);
    data.append("visto_usa", this.state.visto_usa);
    data.append("crea", this.state.crea);
    data.append("crea_titulo", this.state.crea_titulo);
    data.append("crea_expedicao", this.state.crea_expedicao);
    data.append("crea_validade", this.state.crea_validade);
    data.append("aso", this.state.aso);
    data.append("hired", this.state.hired);
    data.append("fired", this.state.fired);
    data.append("mom", this.state.mom);
    data.append("dad", this.state.dad);
    data.append("license", this.state.license);
    data.append("canac", this.state.canac);
    data.append("inscription", this.state.inscription);
    data.append("hour_value", this.state.hour_value);
    data.append("sispat", this.state.sispat);
    data.append("sapiens_code", this.state.sapiens_code);

    var header = this.refs.request_api.header();
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/colaborador/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
          }
        }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar colaborador</h3>
      <Link to="/colaboradores/ativos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <h4>Informações pessoais</h4>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} placeholder="Nome do colaborador" onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>E-mail:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} placeholder="E-mail do colaborador" onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Empresa:</label>
            <Select
              className="form-field-name"
              name="company_id"
              value={this.state.company_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'company_id')}
              options={this.state.companies_select}
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Estado civil:</label>
            <input type="text" className="form-control" name="civil_state" value={this.state.civil_state} placeholder="Estado civil" onChange={this.handleChange.bind(this, 'civil_state')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Telefone:</label>
            <input type="text" className="form-control" name="phone1" value={this.state.phone1} placeholder="Telefone do colaborador" onChange={this.handleChange.bind(this, 'phone1')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Celular:</label>
            <input type="text" className="form-control" name="phone2" value={this.state.phone2} placeholder="Telefone do colaborador" onChange={this.handleChange.bind(this, 'phone2')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Tipo sanguíneo:</label>
            <input type="text" placeholder="Dados Bancários" className="form-control" name="blood_type" value={this.state.blood_type} onChange={this.handleChange.bind(this, 'blood_type')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Dados bancários:</label>
            <input type="text" placeholder="Dados bancários" className="form-control" name="dados_bancarios" value={this.state.dados_bancarios} onChange={this.handleChange.bind(this, 'dados_bancarios')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nascimento:</label>
            <InputMask value={this.state.date_of_birth} placeholder="Nascimento do colaborador" maskChar={null} name="date_of_birth" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_of_birth')}/>
          </div>
          <div className="col-md-6 form-group">
            <label>País nascimento:</label>
            <input type="text" placeholder="País nascimento" className="form-control" name="country" value={this.state.country} onChange={this.handleChange.bind(this, 'country')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>UF nascimento:</label>
            <Select
              className=""
              name="uf_birth"
              value={this.state.uf_birth}
              searchable={true}
              placeholder={'Selecione o UF'}
              onChange={this.handleSelectChange.bind(this, 'uf_birth')}
              options={this.state.uf_list}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>Cidade nascimento:</label>
            <input type="text" placeholder="Cidade nascimento" className="form-control" name="city_birth" value={this.state.city_birth} onChange={this.handleChange.bind(this, 'city_birth')} />
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Endereço:</label>
            <input type="text" className="form-control" placeholder="Endereço do colaborador" name="address" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Número:</label>
            <input type="text" placeholder="Número" className="form-control" name="number" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Complemento:</label>
            <input type="text" placeholder="Complemento" className="form-control" name="complement" value={this.state.complement} onChange={this.handleChange.bind(this, 'complement')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Bairro:</label>
            <input type="text" placeholder="Bairro do colaborador" className="form-control" name="neighborhood" value={this.state.neighborhood} onChange={this.handleChange.bind(this, 'neighborhood')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Cidade:</label>
            <input type="text" placeholder="Cidade do colaborador" className="form-control" name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
          <div className="col-md-6 form-group">
            <label>UF:</label>
            <Select
              className=""
              name="uf_birth"
              value={this.state.uf_birth}
              searchable={true}
              placeholder={'Selecione o UF'}
              onChange={this.handleSelectChange.bind(this, 'uf_birth')}
              options={this.state.uf_list}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>País:</label>
            <input type="text" placeholder="País" className="form-control" name="country" value={this.state.country} onChange={this.handleChange.bind(this, 'country')} />
          </div>
          <div className="col-md-6 form-group">
            <label>PIS:</label>
            <input type="text" placeholder="PIS" className="form-control" name="pis" value={this.state.pis} onChange={this.handleChange.bind(this, 'pis')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>CEP:</label>
            <input type="text" placeholder="CEP do colaborador" className="form-control" name="cep" value={this.state.cep} onChange={this.handleChange.bind(this, 'cep')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Foto:</label>
            <input type="text" type="file" name="photo" className="form-control input-photo" placeholder="Arquivo" value={this.state.photo} onChange={this.handleChange.bind(this, 'photo')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>CPF:</label>
            <input type="text" placeholder="CPF do colaborador" className="form-control" name="cpf" value={this.state.cpf} onChange={this.handleChange.bind(this, 'cpf')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Identidade:</label>
            <input type="text" className="form-control" name="identity" value={this.state.identity} onChange={this.handleChange.bind(this, 'identity')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>ID UF:</label>
            <input type="text" placeholder="Estado de emissão da ID" className="form-control" name="id_uf" value={this.state.id_uf} onChange={this.handleChange.bind(this, 'id_uf')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Orgão de Expedição:</label>
            <input type="text" placeholder="Orgão expeditor da ID" className="form-control" name="id_exp" value={this.state.id_exp} onChange={this.handleChange.bind(this, 'id_exp')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>ID Expedição:</label>
            <InputMask value={this.state.id_date} placeholder="Expedição da ID" maskChar={null} name="id_date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'id_date')}/>
          </div>
          <div className="col-md-6 form-group">
            <label>Carteira de Trabalho UF:</label>
            <input type="text" className="form-control" placeholder="Carteira de trabalho UF" name="ctps_uf" value={this.state.ctps_uf} onChange={this.handleChange.bind(this, 'ctps_uf')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Carteira de Trabalho Profissional:</label>
            <input type="text" className="form-control" placeholder="Carteira de trabalho profissional" name="ctps" value={this.state.ctps} onChange={this.handleChange.bind(this, 'ctps')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Carteira de Trabalho Expedição:</label>
            <InputMask value={this.state.ctps_expedition} placeholder="Carteira de trabalho expedição" maskChar={null} name="ctps_expedition" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ctps_expedition')}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Escola/Formação:</label>
            <input type="text" placeholder="Escola/Formação" className="form-control" name="escola_formacao" value={this.state.escola_formacao} onChange={this.handleChange.bind(this, 'escola_formacao')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Escolaridade:</label>
            <input type="text" placeholder="Escolaridade" className="form-control" name="scholarly" value={this.state.scholarly} onChange={this.handleChange.bind(this, 'scholarly')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Confidence US:</label>
            <input type="text" placeholder="Nº do cartão confidence americano" className="form-control" name="confidence_us" value={this.state.confidence_us} onChange={this.handleChange.bind(this, 'confidence_us')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Expiração confidence US:</label>
            <InputMask value={this.state.expire_us} placeholder="Validade do cartão confidence americano" maskChar={null} name="expire_us" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expire_us')}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Confidence EU:</label>
            <input type="text" className="form-control" placeholder="Nº do cartão confidence europeu" name="confidence_eu" value={this.state.confidence_eu} onChange={this.handleChange.bind(this, 'confidence_eu')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Expiração confidence EU:</label>
            <InputMask value={this.state.expire_eu} placeholder="Validade do cartão confidence europeu" maskChar={null} name="expire_eu" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expire_eu')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Passaporte:</label>
            <input type="text" placeholder="Nº do passaporte" className="form-control" name="passport" value={this.state.passport} onChange={this.handleChange.bind(this, 'passport')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Passaporte Expiração:</label>
            <InputMask value={this.state.passport_expiration} placeholder="Expiração do passaporte" maskChar={null} name="passport_expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'passport_expiration')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Título de Eleitor:</label>
            <input type="text" placeholder="Título de eleitor" className="form-control" name="voting_title" value={this.state.voting_title} onChange={this.handleChange.bind(this, 'voting_title')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Zona de Eleitor:</label>
            <input type="text" placeholder="Zona de eleitor" className="form-control" name="voting_title_zone" value={this.state.voting_title_zone} onChange={this.handleChange.bind(this, 'voting_title_zone')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Sessão de Eleitor:</label>
            <input type="text" placeholder="Sessão de eleitor" className="form-control" name="voting_title_session" value={this.state.voting_title_session} onChange={this.handleChange.bind(this, 'voting_title_session')} />
          </div>
          <div className="col-md-6 form-group">
            <label>CNH categoria:</label>
            <input type="text" placeholder="CNH categoria" className="form-control" name="cnh_cat" value={this.state.cnh_cat} onChange={this.handleChange.bind(this, 'cnh_cat')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>CNH:</label>
            <input type="text" placeholder="Nº da carteira de motorista" className="form-control" name="cnh" value={this.state.cnh} onChange={this.handleChange.bind(this, 'cnh')} />
          </div>
          <div className="col-md-6 form-group">
            <label>CNH expiração:</label>
            <input type="text" placeholder="Expiração da carteira de motorista" className="form-control" name="cnh_expiration" value={this.state.cnh_expiration} onChange={this.handleChange.bind(this, 'cnh_expiration')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Reservista:</label>
            <input type="text" placeholder="Reservista" className="form-control" name="reservista" value={this.state.reservista} onChange={this.handleChange.bind(this, 'reservista')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Reservista categoria:</label>
            <input type="text" placeholder="Reservista categoria" className="form-control" name="reservista_cat" value={this.state.reservista_cat} onChange={this.handleChange.bind(this, 'reservista_cat')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Certificado Militar:</label>
            <input type="text" placeholder="Certificado militar" className="form-control" name="certificado_militar" value={this.state.certificado_militar} onChange={this.handleChange.bind(this, 'certificado_militar')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Certificado Militar Ministério:</label>
            <input type="text" placeholder="Certificado militar ministério" className="form-control" name="certificado_militar_ministerio" value={this.state.certificado_militar_ministerio} onChange={this.handleChange.bind(this, 'certificado_militar_ministerio')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Certificado militar observações:</label>
            <input type="text" placeholder="Certificado Militar Observações" className="form-control" name="certificado_militar_obs" value={this.state.certificado_militar_obs} onChange={this.handleChange.bind(this, 'certificado_militar_obs')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Visto Americano:</label>
            <input type="text" placeholder="Visto Americano" className="form-control" name="visto_usa" value={this.state.visto_usa} onChange={this.handleChange.bind(this, 'visto_usa')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>CREA:</label>
            <input type="text" placeholder="CREA" className="form-control" name="crea" value={this.state.crea} onChange={this.handleChange.bind(this, 'crea')} />
          </div>
          <div className="col-md-6 form-group">
            <label>CREA título:</label>
            <input type="text" placeholder="CREA título" className="form-control" name="crea_titulo" value={this.state.crea_titulo} onChange={this.handleChange.bind(this, 'crea_titulo')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>CREA expedição:</label>
            <input type="text" placeholder="CREA expedição" className="form-control" name="crea_expedicao" value={this.state.crea_expedicao} onChange={this.handleChange.bind(this, 'crea_expedicao')} />
          </div>
          <div className="col-md-6 form-group">
            <label>CREA validade:</label>
            <input type="text" placeholder="CREA validade" className="form-control" name="crea_validade" value={this.state.crea_validade} onChange={this.handleChange.bind(this, 'crea_validade')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>ASO:</label>
            <input type="text" placeholder="ASO" className="form-control" name="aso" value={this.state.aso} onChange={this.handleChange.bind(this, 'aso')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Contratação:</label>
            <input type="text" placeholder="Contratação" className="form-control" name="hired" value={this.state.hired} onChange={this.handleChange.bind(this, 'hired')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Demissão:</label>
            <input type="text" placeholder="Demissão" className="form-control" name="fired" value={this.state.fired} onChange={this.handleChange.bind(this, 'fired')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Nome da mãe:</label>
            <input type="text" placeholder="Nome da mãe do colaborador" className="form-control" name="mom" value={this.state.mom} onChange={this.handleChange.bind(this, 'mom')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Nome do pai:</label>
            <input type="text" placeholder="Nome do pai do colaborador" className="form-control" name="dad" value={this.state.dad} onChange={this.handleChange.bind(this, 'dad')} />
          </div>
        </div>
        <hr></hr>
        <h4>Informações Profissionais</h4>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Licença:</label>
            <input type="text" placeholder="Licença" className="form-control" name="license" value={this.state.license} onChange={this.handleChange.bind(this, 'license')} />
          </div>
          <div className="col-md-6 form-group">
            <label>CANAC:</label>
            <input type="text" placeholder="CANAC" className="form-control" name="canac" value={this.state.canac} onChange={this.handleChange.bind(this, 'canac')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Matrícula:</label>
            <input type="text" placeholder="Inscrição do colaborador" className="form-control" name="inscription" value={this.state.inscription} onChange={this.handleChange.bind(this, 'inscription')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Valor hora:</label>
            <input type="text" placeholder="Valor hora" className="form-control" name="hour_value" value={this.state.hour_value} onChange={this.handleChange.bind(this, 'hour_value')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Contrato SISPAT:</label>
            <input type="text" placeholder="Contrato SISPAT" className="form-control" name="sispat" value={this.state.sispat} onChange={this.handleChange.bind(this, 'sispat')} />
          </div>
          <div className="col-md-6 form-group">
            <label>Código Sapiens:</label>
            <input type="text" placeholder="Código Sapiens" className="form-control" name="sapiens_code" value={this.state.sapiens_code} onChange={this.handleChange.bind(this, 'sapiens_code')} />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Cadastrar colaborador</button>
      </form>
      </div>
  </div>
</div>
    );
  }
}

export default StaffsAdd;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsAdd.js